import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from './components/Layout';
import App from './App';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import About from './pages/About';
import FindYourEdge from './pages/FindYourEdge';
import ConversionUnlocker from './pages/ConversionUnlocker';
import DecisionTree from './pages/DecisionTree';
import Comparison from './pages/Comparison';
import MondayPresentation from './pages/presentations/monday/MondayPresentation';
import MedalliaComparison from './pages/MedalliaComparison';
import './index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <App /> },
      { path: 'checkout/success', element: <CheckoutSuccess /> },
      { path: 'checkout/cancel', element: <CheckoutCancel /> },
      { path: 'privacy', element: <Privacy /> },
      { path: 'terms', element: <Terms /> },
      { path: 'about', element: <About /> },
      { path: 'find-your-edge', element: <DecisionTree /> },
      { path: 'tools/decision-tree', element: <DecisionTree /> },
      { path: 'tools/conversion-unlocker', element: <ConversionUnlocker /> },
      { path: 'comparison', element: <Comparison /> },
      { path: 'comparison/medallia', element: <MedalliaComparison /> },
      { path: 'presentations/monday', element: <MondayPresentation /> }, // Updated path to match URL
    ],
  },
]);

const root = createRoot(document.getElementById('root')!);
root.render(<RouterProvider router={router} />);